import { FLYBITS } from '../../../constants';
import axios from '../../../utils/axios';
import { IFFConfig } from '../types/config';

export const updateConfig = async (accessToken: string, tenantId: string, partialConfig: any): Promise<IFFConfig> => {
    const response = await axios.put(FLYBITS.CONFIGS_HOST + `/tenants/${tenantId}/integrations`, {
        ...partialConfig,
        name: 'openweathermap',
    }, {
        headers: {
            Authorization: accessToken,
        },
        validateStatus: (status: number) => true,
    });
    return response.data
}

export const getConfig = async (accessToken: string, tenantId: string): Promise<IFFConfig> => {
    const response = await axios.get(FLYBITS.CONFIGS_HOST + `/tenants/${tenantId}/integrations/openweathermap?initialize=true`, {
        headers: {
            Authorization: accessToken,
        },
        validateStatus: (status: number) => true,
    });
    return response.data
}



// WEBPACK FOOTER //
// ./src/sub-projects/openweathermap/services/config.ts